'use client';

import { createContext, useContext } from 'react';

import type { LANGUAGES } from '@crehana/ts-types';
import { useSearchParams } from 'next/navigation';

import { useTalentAuth } from '../TalentAuth';
import { getLanguageUser } from '../utils';

type TContext = LANGUAGES;

type TLanguageProviderProps = {
  children: React.ReactNode;
  language: LANGUAGES;
};

const Context = createContext<TContext | undefined>(undefined);

export const LanguageProvider = ({
  children,
  language,
}: TLanguageProviderProps) => {
  const { user } = useTalentAuth();
  const searchParams = useSearchParams();
  const queryLanguage = (searchParams.get('language') as LANGUAGES) || null;

  const languageUser = queryLanguage || getLanguageUser(user) || language;

  return <Context.Provider value={languageUser}>{children}</Context.Provider>;
};

export const useLanguage = () => {
  const result = useContext(Context);
  if (typeof result === 'undefined') {
    throw new Error(
      'The useLanguage hook must be used within a LanguageProvider component.',
    );
  }
  return result;
};
